export default {
  data: () => ({    
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    },
    mode() {
      return this.$store.getters.mode;
    },
    idMode0() {
      return this.$store.getters.idMode0;
    },
    doNext() {
      return this.$store.getters.doNext;
    },
    isFirstAnswer() {
      return this.$store.getters.isFirstAnswer
    },
    modeK() {
      return this.$store.getters.modeK
    },
    isToRepeat() {
      return this.$store.getters.isToRepeat
    },
    isToCheckVerb() {
      return this.$store.getters.isToCheckVerb
    },
    satzes() {
      return this.$store.getters.satzes;
    },
    satz() {
      return this.$store.getters.satz;
    },
    quantityWordsInSatz() {
      return this.satz.wordsId.split(";").length;
    },
    tipp() {
      return this.$store.getters.tipp;
    },
    verify_result() {
      return this.$store.getters.verify_result;
    },
    progressMode_erSatz_percent() {
      let p = Number(this.$store.getters.progressMode[2]);
      return (p * 100).toFixed(2);
    },
    sound() {
      const path = "/audio/satz/";
      const name = this.satz.id + ".mp3";
      return new Audio(path + name);
    }
  },
  methods: {
    async next() {
      if (!this.satz.id) {
        this.$store.commit("setDoNext", { doNext: 1 });
        this.$store.commit("setIsFirstAnswer", { isFirstAnswer: true });
        this.$store.commit("setModeK", { modeK: 1.0 });
        this.$store.commit("setIsToRepeat", { isToRepeat: false });
        this.$store.commit("setIsToCheckVerb", { isToCheckVerb: false });
      }
      if (this.idModeRegime !== 'hor') {
        this.$v.$reset();
      }
      if (this.idModeRegime === 'sp') {
        this.not_recognized = null;
      }
      // doNext - флаг что делать по кнопке NEXT:
      // 1 - очистить всё и вывести следующее задание. При Horen повтор, doNext всегда =1
      // 2 - проверить ответ, вывести результаты
      // 3 - очистить ответ, результаты и повторить задание - бесконечное количество раз до правильного ответа
      // 4 - очистить ответ, результаты и повторить задание - только один раз при ошибке в глаголе, для оценки его формы
      switch (this.doNext) {
        case 1:
          if (this.idModeRegime !== 'hor') {
            this.answerSatzDE = "";
            this.inputAnswerVisible = true;
            this.verifyResultVisible = false;
            this.tippVisible = false;
          }
          //выбрать и вывести новое задание
          // В режиме Horen при запросе NextTask пишется сразу прогресс по этому Satz
          await this.getNextTask();

          if (this.idModeRegime !== 'hor') {
            // запустить таймер
            // время зависит от количества слов в предложении
            this.startTimer(5 + 5 * this.quantityWordsInSatz);
            this.$store.commit("setModeK", { modeK: 1.0 });
            this.$store.commit("setIsFirstAnswer", { isFirstAnswer: true });
          } else {
            this.getTipp();
            this.tippVisible = true;
          }

          if (this.idModeRegime !== 'hor') {
            this.$store.commit("setDoNext", { doNext: 2 });
          } else {
            this.$store.commit("setDoNext", { doNext: 1 });
          }

          break;

        case 2:
          if (this.$v.$invalid) {
            this.$v.$touch();
            return;
          }
          // останавливаем таймер
          this.stopTimer();

          // проверить ответ
          await this.getVerifyResult();
          if (!this.verify_result) {
            break;
          }
          switch (this.verify_result.result) {
            case "ok":
              this.textVerifyResult = "Превосходно! Всё правильно.";
              this.typeVerifyResult = "ok";
              this.$store.commit("setIsToRepeat", { isToRepeat: false });
              this.$store.commit("setIsToCheckVerb", { isToCheckVerb: false });
              this.$store.commit("setDoNext", { doNext: 1 });
              break;

            case "word":
              this.textVerifyResult = "Есть ошибки. Нужно повторить.";
              this.typeVerifyResult = "word";
              this.$store.commit("setIsToRepeat", { isToRepeat: true });
              this.$store.commit("setIsToCheckVerb", { isToCheckVerb: false });
              this.$store.commit("setDoNext", { doNext: 3 });
              break;

            case "verb":
              // Не указан верно глагол. Чтобы оценить грамматику глагола попробуйте ещё раз с подсказкой
              // может только 1 раз для Satz.
              if (this.isFirstAnswer) {
                this.textVerifyResult =
                  "Не указан верно глагол. ";
                this.typeVerifyResult = "verb";
                this.$store.commit("setIsToRepeat", { isToRepeat: true });
                this.$store.commit("setIsToCheckVerb", { isToCheckVerb: true });
                this.$store.commit("setDoNext", { doNext: 4 });
              } else {
                this.textVerifyResult = "Есть ошибки. Нужно повторить.";
                this.typeVerifyResult = "word";
                this.$store.commit("setIsToRepeat", { isToRepeat: true });
                this.$store.commit("setIsToCheckVerb", { isToCheckVerb: false });
                this.$store.commit("setDoNext", { doNext: 3 });
              }
              break;
          }
          this.inputAnswerVisible = false;
          this.verifyResultVisible = true;
          this.$store.commit("setIsFirstAnswer", { isFirstAnswer: false });
          break;

        case 3:
          this.answerSatzDE = "";
          this.inputAnswerVisible = true;
          this.verifyResultVisible = false;
          this.tippVisible = false;
          this.$store.commit("setDoNext", { doNext: 2 });
          break;

        case 4:
          this.answerSatzDE = "";
          this.inputAnswerVisible = true;
          this.verifyResultVisible = false;
          this.tippVisible = false;
          this.$store.commit("setDoNext", { doNext: 2 });
          break;
      }
    },


    async getNextTask() {
      // В режиме Horen при запросе NextTask пишется сразу прогресс по этому Satz
      this.loading = true;
      await this.$store.dispatch("getCourseModeRegimeNextTask", {
        idUser: this.user.id,
        idMode0: this.idMode0,
        idMode: this.mode.id
      });
      this.loading = false;
    },

    async getVerifyResult() {
      this.$store.commit("setVerifyResult", null);
      this.loading = true;
      await this.$store.dispatch("getCourseModeRegimeVerifyResult", {
        idUser: this.user.id,
        idMode0: this.idMode0,
        idMode: this.mode.id,
        idSatz: this.satz.id,
        answerPerson: this.answerSatzDE,
        modeK: this.modeK,
        isToRepeat: this.isToRepeat,
        isToCheckVerb: this.isToCheckVerb
      });
      this.loading = false;
    },

    async getTipp() {
      if (!this.tipp.idSatz || this.satz.id !== this.tipp.idSatz) {
        await this.$store.dispatch("getCourseModeRegimeTipp", {
          idUser: this.user.id,
          id: this.satz.id
        });
      }
      if (this.idModeRegime !== 'hor') {
        this.stopTimer();
        this.$store.commit("setModeK", { modeK: 0.2 });
        this.tippVisible = true;
        this.tippVisible = true;
        this.tippVisible = true;
        this.tippVisible = true;
        this.tippVisible = true;
      }
      this.playSatz();
    },

    playSatz() {
      let that = this;
      this.sound.play().catch(function () {
        that.$store.commit("setErrorMain", "error_play_audio");        
        that.playingSatz = false;
        return;
      });
      this.playingSatz = true;      
      this.sound.onended = function () {
        that.playingSatz = false;
      };

    }
  },
};
